/**
 * Number component to display a colored number.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.numberBgColors - Background color for the number.
 * @param {string} props.numberText - Text to be displayed as the number.
 * @returns {JSX.Element} Returns the Number component.
 */

import React from "react";

export default function Number({ numberBgColors, numberText }) {
  return (
    <div className="flex justify-center">
      <div
        style={{ backgroundColor: numberBgColors }}
        className="rounded-[6px] lg:rounded-[8px] px-[12px] lg:px-[16px] py-[8px] lg:py-[11px] eyebrow-regular"
      >
        {numberText}
      </div>
    </div>
  );
}
